const styles = {
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    mt: {
      xs: 4,
      md: 0,
    },
  },
  infoContent: {
    width: {
      xs: '100%',
      md: 356,
    },
  },
  title: {
    mb: 4,
    letterSpacing: '0.25px',
  },
  text: {
    mb: 6,
    lineHeight: 1.43,
    color: 'neutral.main',
  },
  imageWrapper: {
    flex: 1,
  },
}

export default styles
